import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const InvoiceStatusField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`pos.invoice_status.${record[source]}`) } </span>
      );
};

InvoiceStatusField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default InvoiceStatusField;
